import { type DocumentReference } from 'firebase/firestore';

import { DocumentCollectionType } from 'types/DocumentCollectionType';
import { DocumentType } from 'types/DocumentType';
import { type LogEntry } from 'types/LogEntry';
import { nullTimestamp } from 'utils/FirestoreUtils';

import { DocumentSchema } from './DocumentSchema';
import DocumentStore from './DocumentStore';

export class VideoBundleElementSchema extends DocumentSchema {
    adId = '';
    bitrate = 0;
    bufferSize = 0;
    captureCloudTask = '';
    captureEnqueueTime = 0;
    createTime = nullTimestamp();
    dimensions: [number, number] = [NaN, NaN];
    duration = 0;
    entry = '';
    errors: string[] = [];
    filename = '';
    frameRate = 0;
    label = '';
    log: LogEntry[] = [];
    maxBitrate = 0;
    minBitrate = 0;
    modifiedTime = nullTimestamp();
    stagePrefix = '';
    status: 'notset' | 'pending' | 'new' | 'changing' | 'complete' | 'error' =
        'notset';
    tempPrefix = '';
    videoStorage = '';
}

export class VideoBundleElement extends DocumentStore<VideoBundleElementSchema> {
    type = DocumentType.VIDEO_BUNDLE_ELEMENT;
    collectionType = DocumentCollectionType.VIDEO_BUNDLE_ELEMENT;
    schema = new VideoBundleElementSchema();

    constructor(parent: unknown, docRef?: DocumentReference) {
        super(parent, docRef);
        this.becomeObservable();
    }
}

export function estimateVideoItemTaskProgress(task: VideoBundleElementSchema) {
    switch (task.status) {
        case 'complete':
            return 1;
        case 'error':
            return 0;
        default: {
            if (task.videoStorage) {
                // capture complete, just needs to tick over to status=complete
                return 0.9;
            }
            if (task.captureCloudTask) {
                // either enqueued or performing capture
                return 0.15;
            }
            if (task.entry) {
                // src instance is built and ready for the browser to hit it
                return 0.1;
            }
            if (task.bitrate) {
                // dynamic data has been scraped and validated
                return 0.05;
            }
            // it's brand new
            return 0;
        }
    }
}
